/* Dakol v1: rejestr komponentow, reduced motion, licznik koszyka, publikacja zdarzen.
   Komponenty laduja sie przez import() z mapy importow w theme.liquid przy pierwszej interakcji
   albo gdy element wejdzie w widok. Zero bibliotek. */

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
const root = document.documentElement;
root.classList.add('js');
const applyMotion = () => root.classList.toggle('reduced-motion', reduced.matches);
applyMotion();
reduced.addEventListener('change', applyMotion);

/* Adres modulu: data-asset-base na <script> base.js (adres CDN motywu), nazwa z slownika + .js. */
const assetBase = document.querySelector('script[data-asset-base]')?.dataset.assetBase || '';
/* Mapa z theme.liquid (data-asset-map): kazdy modul ma wlasny parametr wersji z asset_url; podmiana nazwy w adresie base.js
   zostaje jako zapas (CDN buforowal stary modul, dopoki nie zmienil sie base.js). */
let assetMap = {};
try { assetMap = JSON.parse(document.querySelector('script[data-asset-map]')?.textContent || '{}'); } catch (e) { assetMap = {}; }
function assetUrl(name) {
  return assetMap[name] || assetBase.replace(/base\.js(\?.*)?$/, `${name}.js$1`);
}
const loaded = new Map();
function load(name) {
  if (!loaded.has(name)) {
    loaded.set(name, import(assetUrl(name)).catch((e) => { loaded.delete(name); throw e; }));
  }
  return loaded.get(name);
}

/* data-component="nazwa" na elemencie custom element; data-load="visible" laduje przy wejsciu w widok,
   domyslnie przy pierwszej interakcji (pointerdown, focusin, click, keydown). */
const interactionEvents = ['pointerdown', 'focusin', 'keydown', 'click'];
function bindInteraction(el) {
  const name = el.dataset.component;
  let pending = null;
  const once = (e) => {
    interactionEvents.forEach((ev) => el.removeEventListener(ev, once, true));
    pending = load(name).then(() => el.dispatchEvent(new CustomEvent('component:ready', { bubbles: false })));
  };
  /* Pierwsze dotkniecie na telefonie (M2): klik w przycisk wysylajacy formularz albo w link trafial do przegladarki,
     zanim modul sie zaladowal (karta przechodzila na /cart). Wstrzymujemy domyslna akcje i powtarzamy klik po zaladowaniu.
     J1: takze kazdy inny przycisk (ilosc plus i minus, zamykanie), zeby pierwszy klik nie przepadal; gdy modul sie nie
     zaladuje, przycisk wysylajacy wysyla formularz, a link przechodzi pod swoj adres (jak bez JS). */
  const guard = (e) => {
    el.removeEventListener('click', guard, true);
    if (!pending && !loaded.has(name)) once(e);
    const target = e.target.closest('button, a[href], [data-add-button]');
    if (!target || !pending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pending.then(() => { pending = null; target.click(); }, () => {
      if (target.matches('button[type="submit"], [data-add-button]')) target.closest('form')?.requestSubmit?.();
      else if (target.matches('a[href]')) location.assign(target.href);
    });
  };
  el.addEventListener('click', guard, { capture: true });
  interactionEvents.forEach((ev) => el.addEventListener(ev, once, { capture: true, once: false }));
}
let io;
function bindVisible(el) {
  io ??= new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      load(entry.target.dataset.component);
    });
  }, { rootMargin: '200px' });
  io.observe(el);
}
function registerAll(scope = document) {
  scope.querySelectorAll('[data-component]:not([data-registered])').forEach((el) => {
    el.dataset.registered = '1';
    if (el.dataset.load === 'visible') bindVisible(el);
    else if (el.dataset.load === 'now') load(el.dataset.component);
    else bindInteraction(el);
  });
}
registerAll();
new MutationObserver((muts) => {
  for (const m of muts) {
    for (const n of m.addedNodes) if (n.nodeType === 1) registerAll(n.parentNode || document);
  }
}).observe(document.body, { childList: true, subtree: true });

/* Otwieranie szuflad: przycisk z data-open-dialog="id"; element <dialog id> ma data-component z modulem.
   Bez JS przycisk to link (np. /cart) albo <details>. */
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-open-dialog]');
  if (!trigger) return;
  const dialog = document.getElementById(trigger.dataset.openDialog);
  if (!dialog) return;
  e.preventDefault();
  const ready = dialog.dataset.component ? load(dialog.dataset.component) : Promise.resolve();
  ready.then(() => {
    if (typeof dialog.openDrawer === 'function') { dialog.openDrawer(trigger); return; }
    if (dialog.open) return;
    /* Zwykly <dialog> (snippet dialog.liquid) bez wlasnego modulu: fokus na przycisk Zamknij, po zamknieciu powrot na wyzwalacz. */
    dialog.showModal();
    dialog.querySelector('[data-close-dialog]')?.focus();
    dialog.addEventListener('close', () => { if (document.contains(trigger)) trigger.focus(); }, { once: true });
  });
});
document.addEventListener('click', (e) => {
  const close = e.target.closest('[data-close-dialog]');
  if (!close) return;
  const dialog = close.closest('dialog');
  if (dialog) (typeof dialog.closeDrawer === 'function' ? dialog.closeDrawer() : dialog.close());
});

/* Zdarzenia wlasne: dakolEvent(nazwa, dane). Most do pikseli buduje dev-dane w fali 5. */
window.dakolEvent = function dakolEvent(name, data = {}) {
  const detail = { name, data, ts: Date.now() };
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, data);
    }
  } catch (err) { /* piksel niedostepny: tylko CustomEvent */ }
  document.dispatchEvent(new CustomEvent('dakol:event', { detail }));
  document.dispatchEvent(new CustomEvent(name, { detail: data }));
  return detail;
};

/* Koszyk: licznik w naglowku i odswiezenie sekcji koszyka bocznego. */
const cart = {
  bubble: () => document.getElementById('cart-icon-bubble'),
  setCount(n) {
    const b = this.bubble();
    if (!b) return;
    b.textContent = n;
    b.dataset.count = n;
    const label = b.closest('[data-cart-label]');
    if (label) label.setAttribute('aria-label', label.dataset.cartLabel.replace('%d', n));
    if (!reduced.matches) {
      b.classList.add('is-bumped');
      setTimeout(() => b.classList.remove('is-bumped'), 200);
    }
  },
  /* Odswieza koszyk boczny z Section Rendering API. sectionsHtml: obiekt {'cart-drawer': html} z /cart/add.js. */
  render(sectionsHtml) {
    const drawer = document.getElementById('cart-drawer');
    const html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#cart-drawer');
    if (!fresh) return;
    drawer.dataset.itemCount = fresh.dataset.itemCount;
    drawer.querySelector('[data-cart-drawer-inner]').replaceWith(fresh.querySelector('[data-cart-drawer-inner]'));
    this.setCount(Number(fresh.dataset.itemCount || 0));
    registerAll(drawer);
  },
  async refresh() {
    try {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      this.render(await r.json());
    } catch (err) { /* offline: licznik zostaje */ }
  },
  async open(trigger) {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (drawer.dataset.component) await load(drawer.dataset.component);
    if (typeof drawer.openDrawer === 'function') drawer.openDrawer(trigger);
  }
};
window.dakol = Object.assign(window.dakol || {}, { load, assetUrl, registerAll, cart, reducedMotion: () => reduced.matches });

/* product-form (dev-produkt) publikuje cart:updated z {sections, item_count, open: true}. */
document.addEventListener('cart:updated', (e) => {
  const d = e.detail || {};
  if (d.sections) cart.render(d.sections);
  else cart.refresh();
  if (typeof d.item_count === 'number') cart.setCount(d.item_count);
  if (d.open) cart.open();
});

/* Karta produktu: strzalki przy 2 i wiecej zdjeciach (scroll-snap, przewijanie natywne). */
document.addEventListener('click', (e) => {
  const nav = e.target.closest('[data-card-nav]');
  if (!nav) return;
  e.preventDefault();
  const track = nav.closest('[data-card-media]').querySelector('[data-card-track]');
  if (!track) return;
  const dir = nav.dataset.cardNav === 'next' ? 1 : -1;
  track.scrollBy({ left: dir * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
});
/* Kropki karty podazaja za przewinieciem palcem (zdarzenie scroll nie babelkuje, stad capture). */
document.addEventListener('scroll', (e) => {
  const t = e.target;
  if (!(t instanceof Element) || !t.hasAttribute('data-card-track')) return;
  const dots = t.parentElement.querySelector('.product-card__dots');
  if (dots) dots.classList.toggle('is-second', t.scrollLeft > t.clientWidth / 2);
}, { capture: true, passive: true });

/* Pasek pomocniczy nie ma JS (uwaga Kamila 16.10, D9): komunikaty, ktore sie nie mieszcza, chowa CSS (flex-wrap). */
/* Safari z VoiceOver traci semantykę list przy list-style: none; role=list przywraca liczbę pozycji (listy w szufladach doładowanych później pomijamy). */
document.querySelectorAll('ul.list-plain, ol.list-plain').forEach((l) => l.setAttribute('role', 'list'));

/* Stopka: na komputerze kolumny sa zawsze otwarte, a <summary> wypada z kolejnosci Tab (bez JS i na telefonie: zwykly akordeon). */
const footerDesktop = window.matchMedia('(min-width: 900px)');
function syncFooterAccordions() {
  document.querySelectorAll('.footer__acc').forEach((d) => {
    const s = d.querySelector('summary');
    if (footerDesktop.matches) { d.open = true; s?.setAttribute('tabindex', '-1'); }
    else s?.removeAttribute('tabindex');
  });
}
syncFooterAccordions();
footerDesktop.addEventListener('change', syncFooterAccordions);

/* Link Cookies w stopce otwiera baner zgod Shopify. */
document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-open-consent]');
  if (!link) return;
  const api = window.Shopify && window.Shopify.customerPrivacy;
  if (api && typeof api.showPreferences === 'function') { e.preventDefault(); api.showPreferences(); }
});
